import React from 'react';
import Chart from 'react-apexcharts';

const APIStatusChart = ({ summary }) => {
    const data = [summary?.status2xx || 0, summary?.status3xx || 0, summary?.status4xx || 0, summary?.status5xx || 0];
    
    const options = {
        chart: { type: 'donut' },
        labels: ['2xx Success', '3xx Redirection', '4xx Client Error', '5xx Server Error'],
        colors: ['#2ecc71', '#36d4c7ff', '#f1c40f', '#e74c3c'],
        plotOptions: {
            pie: {
                donut: { size: '65%' }
            }
        },
        dataLabels: { enabled: true },
        legend: { position: 'bottom' }
    };

    return (
        <div className="chart-card">
            <h3>HTTP Status Distribution</h3>
            <Chart options={options} series={data} type="donut" height={300} />
        </div>
    );
};

export default APIStatusChart;
